import Immutable from 'immutable';
import {matchPath} from 'react-router-dom';

import {HOME} from './routes';

const validFluxes = [];

function processFlux(flux) {
  const res = [];
  const len = flux.length - 1;

  if (len === 0) {
    throw new Error('Two steps min required');
  }

  if (len === 1) {
    return [flux];
  }

  for (let i = 0; i < len; i += 1) {
    const current = flux[i];
    const next = flux[i + 1];
    res.push([current, next]);
  }

  return res;
}

const normalizedFluxes = validFluxes.reduce(
  (res, flux) => res.concat(processFlux(flux)),
  []
);

function processNormalizedFluxes(fluxes) {
  let elab = Immutable.Map();

  fluxes.forEach(flux => {
    const [start, next] = flux;
    elab = elab
      .set(
        start,
        elab.has(start) ? elab.get(start).add(next) : Immutable.Set([next])
      )
      .set(
        next,
        elab.has(next) ? elab.get(next).add(start) : Immutable.Set([start])
      );
  });

  return elab;
}

const immutableFluxes = processNormalizedFluxes(normalizedFluxes);

export const fluxes = immutableFluxes.toJS();

export const dataResetPoints = [HOME];

export function checkFlux(currentLocation, targetLocation) {
  const flux = immutableFluxes.entrySeq().find(([location, nextLocations]) => {
    return (
      matchPath(currentLocation, {
        path: location,
        exact: true
      }) &&
      nextLocations.find(next => {
        return matchPath(targetLocation, {
          path: next,
          exact: true
        });
      })
    );
  });

  return Boolean(flux);
}
